import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"

import { updateChoice } from "areas/product/store/actions"

import Stones from "./stones"

const AccentOption = ({ pref }) => {
  const dispatch = useDispatch()
  const wizardData = useSelector((state) => state.wizard.data[pref])
  const selectedChoice = useSelector((state) => state.choices?.[pref])

  const setChoice = useCallback(
    (option) => {
      dispatch(updateChoice(pref, option, true))
    },
    [dispatch, pref]
  )

  if (!wizardData) return null

  return (
    <FocusScope>
      <Stones
        headingTitle={wizardData.heading?.title}
        options={wizardData.options}
        pref={pref}
        selectedChoice={selectedChoice}
        setChoice={setChoice}
      />
    </FocusScope>
  )
}

AccentOption.propTypes = {
  pref: PropTypes.string,
}

export default AccentOption
